import { S3_BUCKET_URL } from '@/constants';
import { HisTypeOptionIdType } from '@/pages/Onboarding/options/HisType/types';

const HIS_TYPE_IMAGE_MAP: Record<HisTypeOptionIdType, string> = {
  twink: `${S3_BUCKET_URL}/paywall/fast-pay-tab-man/MAIN-697/twink.png`,
  daddy: `${S3_BUCKET_URL}/paywall/fast-pay-tab-man/MAIN-697/daddy.png`,
  trans: `${S3_BUCKET_URL}/paywall/fast-pay-tab-man/MAIN-697/transsexual.png`,
  otter: `${S3_BUCKET_URL}/paywall/fast-pay-tab-man/MAIN-697/otter.png`,
  queer: `${S3_BUCKET_URL}/paywall/fast-pay-tab-man/MAIN-697/queer.png`,
  leather: `${S3_BUCKET_URL}/paywall/fast-pay-tab-man/MAIN-697/leather.png`,
  boy: `${S3_BUCKET_URL}/paywall/fast-pay-tab-man/MAIN-697/twink.png`,
  pup: `${S3_BUCKET_URL}/paywall/fast-pay-tab-man/MAIN-697/pup.png`,
  clean_cut: `${S3_BUCKET_URL}/paywall/fast-pay-tab-man/MAIN-697/clean-cut.png`,
  jock_sporty: `${S3_BUCKET_URL}/paywall/fast-pay-tab-man/MAIN-697/sporty.png`,
  bear: `${S3_BUCKET_URL}/paywall/fast-pay-tab-man/MAIN-697/bear.png`,
  geek: `${S3_BUCKET_URL}/paywall/fast-pay-tab-man/MAIN-697/geek.png`,
};

export const getImageByHisType = (
  hisType: HisTypeOptionIdType | null,
): string => {
  if (hisType && HIS_TYPE_IMAGE_MAP[hisType]) {
    return HIS_TYPE_IMAGE_MAP[hisType];
  }
  return `${S3_BUCKET_URL}/paywall/fast-pay-tab-man/MAIN-697/transsexual.png`;
};
